// @ts-nocheck
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

const lists: Styleguide["lists"] = {
    defaultProps: {
        css: css`
            ${spacingStyles()}
            padding-left: ${pxToRem(18)};

            li {
                ${spacingStyles(null, "0.25em")}
                padding-left: 0;
            }
        `,
    },
};

export default lists;
